// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FkA4V","importantInfo":"styles_importantInfo__1g602"};